import axiosFetch from './config';

export const getLoans = async(status, page)=>{
    let token = await localStorage.getItem('token')
    return axiosFetch({
      method:'GET',
      url: `/loans?status=${status}&page=${page}`,
      headers: {
        Authorization: 'Bearer ' + token,
      }
    })
}

export const putLoans = async(data)=>{
  let token = await localStorage.getItem('token')
  return axiosFetch({
    method:'PUT',
    data,
    url: `/loans`,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}